import { render, staticRenderFns } from "./CreateResourceField.vue?vue&type=template&id=42a8e2f6&"
import script from "./CreateResourceField.vue?vue&type=script&lang=js&"
export * from "./CreateResourceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports